import React, { useEffect, useState } from 'react'
import jsPDF from 'jspdf';
import { useCurrencySymbol } from '../../../../utils/currencyUtils';
import CommaConvert from '../../../../utils/CommaConvert';
import { formatAmountComma } from '../../../../utils/decimalAmountUtils';


const ShowApprovedTaskDetailsWizard = ({
    proj,
    items,
    index,
    tasks,
    entries,
    employees,
    projectTrackingWorkEntries,
    hardwareProjectTracking,
    descriptionProjectTracking
}) => {
    const currency = useCurrencySymbol();
    const USAComma = CommaConvert();

    const [activeSection, setActiveSection] = useState(null); // 'taskKey' or 'expenseKey'
    const [selectedDescriptions, setSelectedDescriptions] = useState([]);
    const [selectedWorkEntries, setSelectedWorkEntries] = useState([]);
    const [projectSummary, setProjectSummary] = useState(null);

    useEffect(() => {
        if (!proj || !employees) return;

        // Step 1: Map assigned persons
        const assignedPersons = proj.Assignedperson.map((person) => {
            const matchedEmp = employees.find(
                (emp) => emp.EmpEmail === person.email
            );


            const matchedAllWorkEntries = entries.filter(
                (entry) =>
                    entry.projectid === proj?._id
            );

            const matchedWorkEntries = entries.filter(
                (entry) =>
                    entry.projectid === proj?._id &&
                    entry.taskownerid === matchedEmp?._id
            );

            const matchedDescriptions = tasks.filter(
                (entry) =>
                    entry.projectid === proj?._id &&
                    entry.taskownerid === matchedEmp?._id
            );

            const matchedHardwares = items.filter(
                (entry) =>
                    entry.projectid === proj?._id &&
                    entry.taskownerid === matchedEmp?._id
            );


            const matchedWorkEntriestrue = projectTrackingWorkEntries.filter(
                (entry) =>
                    entry.projectid === proj?._id &&
                    entry.taskownerid === matchedEmp?._id
            );

            const matchedDescriptionstrue = descriptionProjectTracking.filter(
                (entry) =>
                    entry.projectid === proj?._id &&
                    entry.taskownerid === matchedEmp?._id
            );

            const matchedHardwarestrue = hardwareProjectTracking.filter(
                (entry) =>
                    entry.projectid === proj?._id &&
                    entry.taskownerid === matchedEmp?._id
            );

            return {
                name: person.name,
                email: person.email,
                role: matchedEmp?.customRoles?.[0] || null,
                empid: matchedEmp?._id || null,
                workEntries: matchedWorkEntries,
                descriptionList: matchedDescriptions,
                hardwareList: matchedHardwares,
                matchedAllWorkEntries: matchedAllWorkEntries,
                workEntriesrtrue: matchedWorkEntriestrue,
                descriptionListtrue: matchedDescriptionstrue,
                hardwareListtrue: matchedHardwarestrue,
            };
        });

        // Step 2: Move "project manager" to first position
        const sortedAssignedPersons = [
            ...assignedPersons.filter(p => p.role === "project manager"),
            ...assignedPersons.filter(p => p.role !== "project manager")
        ];

        // Step 3: Build summary
        const summary = {
            _id: proj._id,
            TypeService: proj.TypeService,
            ProjectName: proj.ProjectName,
            Assignedperson: sortedAssignedPersons,
        };

        setProjectSummary(summary);
    }, [proj, employees, tasks, entries, descriptionProjectTracking, hardwareProjectTracking, projectTrackingWorkEntries, items]);

    const downloadPDFHardware = (hardwareList) => {
        const doc = new jsPDF();
        doc.autoTable({
            head: [
                [
                    "Sr. No",
                    "Part Name",
                    "Part Number",
                    "Quantity",
                    `Unit Price (${currency})`,
                    `Total Price (${currency})`,
                ],
            ],
            body: hardwareList.map((LeadReport, index) => [
                index + 1,
                LeadReport.assemblepartdescription,
                LeadReport.partno,
                LeadReport.quantity,
                USAComma(LeadReport.unitprice),
                USAComma(LeadReport.totalprice),
            ]),
            styles: {
                fontSize: 7,
            },
            headStyles: {
                fontSize: 8,
            },
        });
        doc.save("Hardware PartList.pdf");
    };

    const downloadPDFHardwareDescriptions = (descriptionList) => {
        const doc = new jsPDF();
        doc.autoTable({
            head: [["Sr. No", "Description", `Amount (${currency}) `, "Notes"]],
            body: descriptionList.map((LeadReport, index) => [
                index + 1,
                LeadReport.description,
                formatAmountComma(LeadReport.value),
                LeadReport.notes,
            ]),
            styles: {
                fontSize: 7,
            },
            headStyles: {
                fontSize: 8,
            },
        });
        doc.save("Hardware OtherExpensesList.pdf");
    };

    const handlePersonClick = (person, taskKey) => {
        // Use descriptionListtrue if descriptionList is empty, otherwise use descriptionList
        setSelectedDescriptions(
            person.descriptionList && person.descriptionList.length > 0
                ? person.descriptionList
                : person.descriptionListtrue || []
        );

        setSelectedWorkEntries(
            person.workEntries && person.workEntries.length > 0
                ? person.workEntries
                : person.workEntriesrtrue || []
        );

        // Toggle the active section
        setActiveSection(activeSection === taskKey ? null : taskKey);
    };

    const handleTabClick = (person, key, type) => {
        setSelectedDescriptions(
            person.descriptionList && person.descriptionList.length > 0
                ? person.descriptionList
                : person.descriptionListtrue || []
        );

        setSelectedWorkEntries(
            person.workEntries && person.workEntries.length > 0
                ? person.workEntries
                : person.workEntriesrtrue || []
        );
        setActiveSection(type === 'task' ? key : `${key}-expense`);
    };

    return (
        <div className="w-full">
            {projectSummary &&
                proj?._id?.toString() === projectSummary?._id?.toString() ? (
                projectSummary.Assignedperson.map((person, idx) => {
                    const taskKey = `${proj.TypeService}-${index}_${person.empid}_${projectSummary.TypeService}_${proj._id}-tasktable`;
                    const expenseKey = `${taskKey}-expense`;
                    const isActive = activeSection === taskKey || activeSection === expenseKey;
                    return (
                        <div key={idx} className="flex flex-col w-full h-full">
                            {/* Person Row */}

                            {person?.hardwareList?.length || person.workEntries?.length || person?.descriptionList?.length ? (
                                <div className="flex ">
                                    <div className="w-[33%] flex justify-center align-middle items-center text-center p-2">
                                        <button
                                            onClick={() => handlePersonClick(person, taskKey)}
                                            className={`${isActive
                                                ? "text-blue-500  rounded-md px-2 py-1"
                                                : "bg-transparent"
                                                } transition-colors duration-200 text-center flex justify-center align-middle items-center`}
                                        >
                                            {projectSummary.TypeService}{" "}
                                            {person.role === "project manager" ? "Manager" : "Employee"}
                                        </button>
                                    </div>
                                    <div className="w-[67%] flex  cursor-pointer">
                                        {proj?.TypeService?.toLowerCase().includes("hardware") ? (
                                            <>
                                                <div
                                                    onClick={() => handlePersonClick(person, taskKey)}
                                                    className="w-[50%] pr-3 flex justify-center items-center ">
                                                    {person?.hardwareList?.length || ""}
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div
                                                    onClick={() => handlePersonClick(person, taskKey)}
                                                    className="w-[50%]  pr-3 flex justify-center items-center ">
                                                    {person.workEntries?.length
                                                        ? person.workEntries.reduce(
                                                            (sum, item) =>
                                                                sum + Number(item.hoursassigned || 0),
                                                            0
                                                        )
                                                        : ""}

                                                </div>
                                            </>
                                        )}

                                        {proj?.TypeService?.toLowerCase().includes("hardware") ? (
                                            // {proj.TypeService === "Hardware" ? (
                                            <div
                                                onClick={() => handlePersonClick(person, expenseKey)}
                                                className="w-[50%] pr-3 flex justify-center items-center">
                                                {person?.descriptionList?.length || ""}
                                            </div>
                                        ) : (
                                            <div
                                                onClick={() => handlePersonClick(person, expenseKey)}
                                                className="w-[50%] pr-3 flex justify-center items-center ">
                                                {person.descriptionList?.length
                                                    ? formatAmountComma(
                                                        person.descriptionList.reduce(
                                                            (sum, item) => sum + Number(item.value || 0),
                                                            0
                                                        )
                                                    )
                                                    : ""
                                                }
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className='w-full h-12 flex justify-center align-middle items-center'>
                                    <div onClick={() => handlePersonClick(person, taskKey)}
                                        className="w-[33%] h-full p-2 cursor-pointer flex justify-center items-center text-center">
                                        {projectSummary.TypeService}
                                        <br />
                                        {person.role === "project manager" ? "Manager" : "Employee"}
                                    </div>
                                    <div
                                        onClick={() => handlePersonClick(person, taskKey)}
                                        className="w-[33%] h-full  cursor-pointer flex justify-center items-center">
                                        {proj?.TypeService?.toLowerCase().includes("hardware") ? (
                                            <>
                                                <div className="h-full flex justify-center items-center">
                                                    {person?.hardwareListtrue?.length || ""}
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="h-full flex justify-center items-center ">
                                                    {person.workEntriesrtrue?.length
                                                        ? person.workEntriesrtrue.reduce(
                                                            (sum, item) =>
                                                                sum + Number(item.hoursassigned || 0),
                                                            0
                                                        )
                                                        : ""}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    <div onClick={() => handlePersonClick(person, expenseKey)}
                                        className="w-[34%] h-full cursor-pointer p-2 flex justify-center items-center  ">
                                        {person.descriptionListtrue?.length
                                            ? formatAmountComma(
                                                person.descriptionListtrue.reduce(
                                                    (sum, item) => sum + Number(item.value || 0),
                                                    0
                                                )
                                            )
                                            : ""
                                        }
                                    </div>
                                </div>
                            )}


                            {isActive && (
                                <div className="p-1 pl-[2%] flex justify-center gap-1 text-[11px] ">
                                    <div
                                        onClick={() => handleTabClick(person, taskKey, 'task')}
                                        className={`cursor-pointer py-1 px-1 inline-block border rounded-md text-start transition-colors duration-200 ${activeSection === taskKey
                                            ? "bg-blue-500 text-white border-blue-500"
                                            : "bg-white border-gray-300 hover:bg-gray-50"
                                            }`}
                                    >
                                        {proj?.TypeService?.toLowerCase().includes("hardware")
                                            ? "Part List"
                                            : "Effort Expenses"}
                                    </div>

                                    <div
                                        onClick={() => handleTabClick(person, expenseKey, 'expense')}
                                        className={`cursor-pointer py-1 px-1 inline-block border rounded-md text-start transition-colors duration-200 ${activeSection === expenseKey
                                            ? "bg-blue-500 text-white border-blue-500"
                                            : "bg-white border-gray-300 hover:bg-gray-50"
                                            }`}
                                    >
                                        Other Expenses
                                    </div>
                                </div>
                            )}

                            {activeSection === taskKey && (
                                <div className='w-full'>
                                    {/* ... rest of your task table rendering code remains the same ... */}
                                    {proj?.TypeService?.toLowerCase().includes("hardware") ? (
                                        // {proj.TypeService === "Hardware" ? (
                                        <div className="flex justify-center w-full mb-2">
                                            <div className=" border border-gray-300  overflow-hidden">
                                                <div className="grid grid-cols-3 bg-blue-500 text-white text-[11px] font-semibold break-all whitespace-normal">
                                                    <div className="p-2 border-r text-center">
                                                        Total Parts
                                                    </div>
                                                    <div className="p-2 border-r text-center">
                                                        Total Price ({currency})
                                                    </div>
                                                    <div className="p-2 text-center">Action</div>
                                                </div>

                                                {(person?.hardwareList?.length) ? (
                                                    <div className="grid grid-cols-3 bg-white text-black text-[11px] break-all whitespace-normal">
                                                        <div className="p-1 border-r border-blue-200 text-center">
                                                            {person?.hardwareList.length}
                                                        </div>
                                                        <div className="p-1 border-r border-blue-200 text-center">
                                                            {currency}
                                                            {USAComma(
                                                                person?.hardwareList?.reduce((sum, item) => {
                                                                    return sum + (item.totalprice || 0);
                                                                }, 0)
                                                            )}
                                                        </div>
                                                        <div
                                                            title="Download Hardware Part List"
                                                            onClick={() =>
                                                                downloadPDFHardware(person?.hardwareList)
                                                            }
                                                            className="p-1 text-center cursor-pointer hover:bg-blue-50"
                                                        >
                                                            Download
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="grid grid-cols-3 bg-white text-black text-[11px] break-all whitespace-normal">
                                                        <div className="p-1 border-r border-blue-200 text-center">
                                                            {person?.hardwareListtrue.length}
                                                        </div>
                                                        <div className="p-1 border-r border-blue-200 text-center">
                                                            {currency}
                                                            {USAComma(
                                                                person?.hardwareListtrue?.reduce((sum, item) => {
                                                                    return sum + (item.totalprice || 0);
                                                                }, 0)
                                                            )}
                                                        </div>
                                                        <div
                                                            title="Download Hardware Part List"
                                                            onClick={() =>
                                                                downloadPDFHardware(person?.hardwareListtrue)
                                                            }
                                                            className="p-1 text-center cursor-pointer hover:bg-blue-50"
                                                        >
                                                            Download
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    ) : (
                                        <div className="flex justify-center mx-auto pb-2">
                                            <div className="w-full max-h-[14rem] overflow-y-auto">
                                                {selectedWorkEntries.length > 0 ? (
                                                    <>
                                                        {selectedWorkEntries.length > 0 && (
                                                            <div className="sticky top-0 w-full">
                                                                <div className=" head flex text-center bg-[#1973eb] text-white text-[11px]">
                                                                    <div className="w-[40%] border p-1">Task</div>
                                                                    <div className="w-[30%] border p-1">
                                                                        Hours
                                                                    </div>
                                                                    <div className="w-[30%] border p-1">
                                                                        Notes
                                                                    </div>
                                                                </div>

                                                                <div className="head flex text-center text-[11px] font-semibold  bg-gray-100">
                                                                    <div className="w-[40%] border break-all whitespace-normal p-1">
                                                                        {"Total"}
                                                                    </div>
                                                                    <div className="w-[30%] border break-all whitespace-normal p-1">
                                                                        {selectedWorkEntries?.reduce(
                                                                            (sum, item) => sum + item.hoursassigned,
                                                                            0
                                                                        ) || 0}
                                                                        {""}
                                                                    </div>
                                                                    <div className="w-[30%] border break-all whitespace-normal p-1">
                                                                        {selectedWorkEntries.length}
                                                                        {" Tasks"}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {selectedWorkEntries.map((entry, index) => (
                                                            <div
                                                                key={index}
                                                                className="head flex text-center text-[11px]"
                                                            >
                                                                <div className="w-[40%] border break-all whitespace-normal p-1">
                                                                    {entry.task}
                                                                </div>
                                                                <div className="w-[30%] border break-all whitespace-normal p-1">
                                                                    {entry.hoursassigned}
                                                                </div>
                                                                <div className="w-[30%] border break-all whitespace-normal p-1">
                                                                    {entry.notes}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <div className="head bg-slate-400 flex text-red-500 text-[11px]">
                                                        <p className="w-full text-center">
                                                            No Data Available
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {activeSection === expenseKey && (
                                <div className='w-full '>
                                    {/* ... rest of your expense table rendering code remains the same ... */}
                                    {proj?.TypeService?.toLowerCase().includes("hardware") ? (
                                        // {proj.TypeService === "Hardware" ? (
                                        <div className="flex justify-center w-full mb-2">
                                            <div className=" border border-gray-300  overflow-hidden">
                                                <div className="grid grid-cols-3 bg-blue-500 text-white text-[11px] font-semibold break-all whitespace-normal">
                                                    <div className="p-1 border-r text-center">
                                                        Total Descriptions
                                                    </div>
                                                    <div className="p-1 border-r text-center">
                                                        Total Amount ({currency})
                                                    </div>
                                                    <div className="p-1 text-center">Action</div>
                                                </div>

                                                <div className="grid grid-cols-3 bg-white text-black text-[11px] break-all whitespace-normal">
                                                    <div className="p-1 border-r border-blue-200 text-center">
                                                        {person.descriptionListtrue?.length}
                                                    </div>
                                                    <div className="p-1 border-r border-blue-200 text-center">
                                                        {currency}
                                                        {formatAmountComma(
                                                            person.descriptionListtrue?.reduce((sum, item) => {
                                                                return sum + (item.value || 0);
                                                            }, 0)
                                                        )}
                                                    </div>
                                                    <div
                                                        title="Download Description List"
                                                        onClick={() =>
                                                            downloadPDFHardwareDescriptions(
                                                                person.descriptionListtrue
                                                            )
                                                        }
                                                        className="p-1 text-center cursor-pointer hover:bg-blue-50"
                                                    >
                                                        Download
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="flex justify-center mx-auto pb-2">
                                            <div className="w-full max-h-[14rem] overflow-y-auto">
                                                {selectedDescriptions.length > 0 ? (
                                                    <>
                                                        {selectedDescriptions.length > 0 && (
                                                            <div className="sticky top-0">
                                                                <div className=" head flex text-center bg-[#1973eb] text-white text-[11px] break-all whitespace-normal">
                                                                    <div className="w-[40%] border p-1">
                                                                        Description
                                                                    </div>
                                                                    <div className="w-[30%] border p-1">
                                                                        Amount ({currency})
                                                                    </div>
                                                                    <div className="w-[30%] border p-1">
                                                                        Notes
                                                                    </div>
                                                                </div>

                                                                <div className="head flex text-center font-semibold  text-black text-[11px] break-all whitespace-normal bg-gray-100">
                                                                    <div className="w-[40%] border p-1">
                                                                        Total
                                                                    </div>
                                                                    <div className="w-[30%] border p-1">
                                                                        {formatAmountComma(
                                                                            selectedDescriptions?.reduce(
                                                                                (sum, item) => sum + item.value,
                                                                                0
                                                                            ) || 0
                                                                        )}
                                                                    </div>
                                                                    <div className="w-[30%] border p-1">
                                                                        {selectedDescriptions?.length}
                                                                        {" Expenses"}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {selectedDescriptions.map((entry, index) => (
                                                            <div
                                                                key={index}
                                                                className="head flex text-center text-[11px] break-all whitespace-normal"
                                                            >
                                                                <div className="w-[40%] border p-1">
                                                                    {entry.description}
                                                                </div>
                                                                <div className="w-[30%] border p-1">
                                                                    {formatAmountComma(entry.value)}
                                                                </div>
                                                                <div className="w-[30%] border p-1">
                                                                    {entry.notes}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <div
                                                        className="head flex text-red-500 text-[11px]"
                                                    >
                                                        <p className="w-full text-center">
                                                            No Data Available
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })
            ) : (
                <p className="text-gray-500 text-sm">No project summary available</p>
            )}
        </div>
    )
}

export default ShowApprovedTaskDetailsWizard